import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useGithubRepos } from '../../hooks/useGithubRepos';

export const GithubRepoPicker = (
  props: FieldExtensionComponentProps<string>,
) => {
  const { formData, onChange, uiSchema, schema, required } = props;

  const hasWorkflow = uiSchema?.['ui:options']?.hasWorkflow as string | undefined;

  const { repos, loading, error } = useGithubRepos(hasWorkflow);

  const label = schema.title || 'Repository';
  const helperText =
    error ?? (uiSchema?.['ui:help'] as string | undefined) ?? undefined;

  const selected = repos.find(r => r.name === formData) ?? null;

  return (
    <Autocomplete
      options={repos}
      getOptionLabel={option => option.name}
      value={selected}
      onChange={(_, newValue) => onChange(newValue?.name ?? '')}
      disabled={loading}
      loading={loading}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          margin="normal"
          required={required}
          error={!!error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
